export default __webpack_public_path__ + "static/media/Factory05.5fcc8f12.jpg";